import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdmin, isSuperAdmin } from '../utils/roleUtils';

/**
 * Protects admin routes — redirects unauthenticated users and blocks non-admins.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.requireSuperAdmin=false]
 */
function AdminRoute({ children, requireSuperAdmin = false }) {
  const { user, userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div role="status" aria-live="polite" className="text-gray-600">
          Loading...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin(userRole)) {
    return (
      <div className="p-8 text-center" role="alert">
        <h2 className="text-xl font-semibold text-gray-900">Access Denied</h2>
        <p className="mt-2 text-gray-600">Superadmin access is required for this page.</p>
      </div>
    );
  }

  if (!requireSuperAdmin && !isAdmin(userRole)) {
    return (
      <div className="p-8 text-center" role="alert">
        <h2 className="text-xl font-semibold text-gray-900">Access Denied</h2>
        <p className="mt-2 text-gray-600">Admin access is required for this page.</p>
      </div>
    );
  }

  return children;
}

export default AdminRoute;
